import { render } from "./HikvisionFaceModal.vue?vue&type=template&id=3d399e52&ts=true"
import script from "./HikvisionFaceModal.vue?vue&type=script&lang=ts"
export * from "./HikvisionFaceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__